import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Manager, Popper as PopperBase, Reference } from 'react-popper';
import OutsideClickHandler from 'react-outside-click-handler/esm/OutsideClickHandler';

class Popper extends React.Component {

    constructor(props) {
        super(props);
        this._setVisibility = this._setVisibility.bind(this);
        this._toggleVisibility = this._toggleVisibility.bind(this);
        this._handleClickOutside = this._handleClickOutside.bind(this);
        this.state = {
            isOpen: false,
        };
    }

    _handleClickOutside() {
        this._setVisibility(false);
    }

    _setVisibility(value) {
        this.setState({
            isOpen: value,
        });

        if (value && this.props.onShow) this.props.onShow();

        if (!value && this.props.onHide) this.props.onHide();
    }

    _toggleVisibility() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen,
        }), () =>
        {
            if (this.state.isOpen && this.props.onShow) this.props.onShow();

            if (!this.state.isOpen && this.props.onHide) this.props.onHide();
        });
    }

    render() {

        const {
            color, content, minWidth, onHover, reference, shadow, bgColor, placement: placementProp, ...props
        } = this.props;

        const popper = this.state.isOpen
            ? (
                <PopperBase {...props} placement={placementProp} className="tw-z-50">
                    {({
                        ref, style, placement, arrowProps,
                    }) =>
                    {
                        const styles = {};

                        if (placement)
                        {
                            styles[`border${placement[0].toUpperCase() + placement.slice(1)}Color`] = color;
                        }

                        return (
                            <div
                                ref={ref}
                                style={{ ...style, ...{ minWidth } }}
                                data-placement={placement}
                                className={`popper tw-p-8 tw-shadow-lg tw-z-10 ${bgColor}`}
                            >
                                {this.props.content}
                                <div
                                    ref={arrowProps.ref}
                                    style={{ ...arrowProps.style, ...styles }}
                                    className="popper__arrow"
                                />
                            </div>
                        );
                    }}
                </PopperBase>
            )
            : null;

        const eventProperties = onHover
            ? {
                onMouseEnter: () => this._setVisibility(true),
                onMouseLeave: () => this._setVisibility(false),
            }
            : { onClick: this._toggleVisibility };

        return (
            <Manager>
                <OutsideClickHandler disabled={!this.state.isOpen} display="flex" onOutsideClick={this._handleClickOutside}>
                    <Reference>
                        {({ ref }) => (
                            <div className="popper-text tw-w-full tw-inline" ref={ref} {...eventProperties}>
                                {reference}
                            </div>
                        )}
                    </Reference>

                    <Fragment>
                        {popper}
                    </Fragment>
                </OutsideClickHandler>
            </Manager>

        );
    }
}

Popper.defaultProps = {
    color: '#cbd5df',
    minWidth: 350,
    onHover: false,
    placement: 'auto',
};

Popper.propTypes = {
    color: PropTypes.string,
    bgColor: PropTypes.string,
    content: PropTypes.element.isRequired,
    title: PropTypes.string,
    minWidth: PropTypes.number,
    onHover: PropTypes.bool,
    onHide: PropTypes.func,
    onShow: PropTypes.func,
    placement: PropTypes.oneOf([
        'auto', 'auto-start', 'auto-end',
        'top', 'top-start', 'top-end',
        'right', 'right-start', 'right-end',
        'bottom', 'bottom-start', 'bottom-end',
        'left', 'left-start', 'left-end',
    ]),
    reference: PropTypes.element.isRequired,
};

export default Popper;
